import axios from 'axios';
export const TranscriptLoader = async ( transcriptFilename ) => {

  return axios.get('./Assets/Transcripts/' + transcriptFilename + '.txt')

}



// WEBPACK FOOTER //
// ./src/TranscriptLoader.js